import { useState } from "react";

import { ResetPasswordError } from "./components/ResetPasswordError.tsx";
import { ResetPasswordForm } from "./components/ResetPasswordForm.tsx";
import { ResetPasswordSuccess } from "./components/ResetPasswordSuccess.tsx";
import { UserScreenWrapper } from "./components/UserScreenWrapper.tsx";

export const ResetPasswordScreen = () => {
  const [error, setError] = useState("");
  const [success, setSuccess] = useState<boolean>(false);

  return (
    <UserScreenWrapper contentClassName="pb-[85px] sm:pb-0">
      {success ? (
        <ResetPasswordSuccess />
      ) : error ? (
        <ResetPasswordError />
      ) : (
        <ResetPasswordForm
          error={error}
          setError={setError}
          setSuccess={setSuccess}
        />
      )}
    </UserScreenWrapper>
  );
};
